<template>
  <router-view/>
</template>

<script>
export default {
  name: 'app',
};
</script>

<style lang="scss">
:root {
  --header-height: 68px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue?b4eaa462